import {html} from 'lit-html';
import {ifDefined} from 'lit-html/directives/if-defined';
import {live} from 'lit-html/directives/live';

import TemplateRegistry from '../template/template-registry';
import {optionName} from '../template/template-util.js';

TemplateRegistry.templates['hidden'] = (option, config, onChange) => html`
    <input type="hidden" id="${option.id}" name="${optionName(option)}" .value=${live(option.value)} form=${ifDefined(config.productFormLink)}>
`;